import {useDispatch} from 'react-redux'
import {stopLoading, startLoadding} from '../../../Redux/FrontEnd/Loading/LoadingSlice'
import {useRemainingBalanceMutation} from '../../../../services/cellcast.v3'
import {defaultRegion} from '../../../../_metronic/helpers'
import {GetCurrentData} from '../../../Utils/_helpers/GetCurrentData'

type params = {}

export function useAccount() {
  const dispatch = useDispatch()
  const currentUser = GetCurrentData()

  const [getRemainCredit] = useRemainingBalanceMutation()

  const fetchBalanceHistory = (params?: params) => {
    dispatch(startLoadding())
    const result = getRemainCredit({
      action: 'find_balance',
      data: null,
    }).unwrap()
    dispatch(stopLoading())
    return result
  }

  return {
    fetchBalanceHistory,
    isDefaultRegion: currentUser?.region === defaultRegion,
  }
}
